module.exports = __webpack_public_path__ + "img/import.0f0af036.png";